import React from 'react';
import { motion } from 'framer-motion';
import { FileText, Zap, BookOpen, ShieldCheck, RefreshCw } from 'lucide-react';
export function Hero() {
  const scrollToPricing = () => {
    document.getElementById('pricing')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <section className="relative h-[100dvh] w-full flex flex-col items-center justify-center overflow-hidden bg-primary" data-id="element-80">
      {/* Background glow */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[400px] h-[400px] bg-accent-cyan/10 rounded-full blur-[80px] pointer-events-none" data-id="element-81"></div>

      <div className="relative z-10 flex flex-col items-center justify-between h-full w-full max-w-5xl mx-auto px-4 py-8 md:py-12" data-id="element-82">
        {/* 1. Branding */}
        <motion.div initial={{
        opacity: 0,
        y: -10
      }} animate={{
        opacity: 1,
        y: 0
      }} className="shrink-0" data-id="element-83"></motion.div>

        {/* 2. Promise */}
        <motion.div initial={{
        opacity: 0,
        y: 15
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.4
      }} className="flex flex-col items-center text-center max-w-3xl" data-id="element-84">
          <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-primary-card border border-accent-cyan/30 text-accent-cyan text-[10px] font-bold tracking-wider mb-4" data-id="element-85">
            EDICIÓN 2026 - QUIMICA APLICADA
          </div>

          <h1 className="flex flex-col items-center font-bold leading-[1] mb-6 tracking-tight" data-id="element-86">
            <span className="md:text-4xl lg:text-5xl uppercase opacity-90 text-[20px]" data-id="element-87">
              Tu año completo resuelto en
            </span>
            <span className="text-5xl md:text-7xl lg:text-8xl text-accent-cyan mt-1" data-id="element-88">
              30 MINUTOS
            </span>
          </h1>

          <p className="md:text-lg text-text-muted max-w-2xl mx-auto text-[12px]" data-id="element-89">
            Material específico para{' '}
            <strong className="text-text-main font-semibold" data-id="element-90">
              Electromecánica, Electrónica, Informática y Construcciones
            </strong>
            . 16 tomos diseñados por y para la escuela técnica.
          </p>
        </motion.div>

        {/* 3. Mockup */}
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.4,
        delay: 0.1
      }} className="relative w-full max-w-[354px] md:max-w-[531px] flex-1 flex items-center justify-center min-h-0" data-id="element-91">
          <div className="absolute inset-0 bg-accent-cyan/20 blur-[40px] rounded-full" data-id="element-92"></div>
          <img src="https://cdn.magicpatterns.com/uploads/3chkFiLS6sUwcmLhoYorKu/quimica_aplicada_web_1200.webp" alt="Química Aplicada MegaPack 16 Tomos" className="relative z-10 w-full h-full object-contain drop-shadow-2xl" data-id="element-93" />
        </motion.div>

        {/* 4. CTA */}
        <motion.div initial={{
        opacity: 0,
        y: 10
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.4,
        delay: 0.2
      }} className="w-full flex flex-col items-center shrink-0 mt-4" data-id="element-94">
          <motion.button onClick={scrollToPricing} animate={{
          boxShadow: ['0 0 20px rgba(0, 200, 83, 0.3)', '0 0 40px rgba(0, 200, 83, 0.6)', '0 0 20px rgba(0, 200, 83, 0.3)'],
          scale: [1, 1.02, 1]
        }} transition={{
          duration: 2,
          repeat: Infinity,
          ease: 'easeInOut'
        }} className="w-full sm:w-auto bg-accent-green hover:bg-[#00b34a] text-primary font-bold md:text-xl px-12 py-4 rounded-xl transition-all transform hover:scale-105 flex items-center justify-center gap-2 mb-4 text-[16px]" data-id="element-95">
            QUIERO MI MEGAPACK AHORA
          </motion.button>

          <div className="flex flex-wrap justify-center items-center gap-x-4 gap-y-2 text-[10px] md:text-[11px] text-text-muted font-medium uppercase tracking-wider max-w-3xl" data-id="element-96">
            <span className="flex items-center gap-1.5" data-id="element-97">
              <FileText className="w-3.5 h-3.5 text-accent-cyan" data-id="element-98" /> 100% PDF
            </span>
            <span className="hidden md:block w-1 h-1 bg-primary-card rounded-full" data-id="element-99"></span>
            <span className="flex items-center gap-1.5" data-id="element-100">
              <Zap className="w-3.5 h-3.5 text-accent-orange" data-id="element-101" /> Acceso
              inmediato
            </span>
            <span className="hidden md:block w-1 h-1 bg-primary-card rounded-full" data-id="element-102"></span>
            <span className="flex items-center gap-1.5" data-id="element-103">
              <BookOpen className="w-3.5 h-3.5 text-accent-cyan" data-id="element-104" /> Diseño INET
            </span>
            <span className="hidden md:block w-1 h-1 bg-primary-card rounded-full" data-id="element-105"></span>
            <span className="flex items-center gap-1.5" data-id="element-106">
              <ShieldCheck className="w-3.5 h-3.5 text-accent-green" data-id="element-107" /> Compra
              protegida por Mercado Pago
            </span>
            <span className="hidden md:block w-1 h-1 bg-primary-card rounded-full" data-id="element-108"></span>
            <span className="flex items-center gap-1.5" data-id="element-109">
              <RefreshCw className="w-3.5 h-3.5 text-accent-cyan" data-id="element-110" /> 7 días de
              reembolso
            </span>
          </div>
        </motion.div>
      </div>
    </section>;
}